import { render, staticRenderFns } from "./MobileHeaderInfo.vue?vue&type=template&id=27bba75b&scoped=true"
import script from "./MobileHeaderInfo.vue?vue&type=script&lang=js"
export * from "./MobileHeaderInfo.vue?vue&type=script&lang=js"
import style0 from "./MobileHeaderInfo.vue?vue&type=style&index=0&id=27bba75b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bba75b",
  null
  
)

export default component.exports